import { ADMIN_USERS_ENDPOINTS, AdminUsersService } from "@/service/api/admin-users";
import { useQuery } from "@tanstack/react-query";
import { useEffect } from "react";
import { toast } from "react-toastify";

const useUsersTotalizers = () => {
  const query = useQuery({
    queryKey: [ADMIN_USERS_ENDPOINTS.GET_TOTALIZERS],
    queryFn: AdminUsersService.getTotalizers,
    retry: false,
  });

  useEffect(() => {
    if (query.isError) {
      toast.error(query.error?.message || "Erro ao carregar totalizadores.");
    }
  }, [query.isError, query.error]);

  return query;
};

export default useUsersTotalizers;
